import { render } from "./ListMtCatAdmin.vue?vue&type=template&id=00312755&scoped=true"
import script from "./ListMtCatAdmin.vue?vue&type=script&lang=js"
export * from "./ListMtCatAdmin.vue?vue&type=script&lang=js"

import "./ListMtCatAdmin.vue?vue&type=style&index=0&id=00312755&scoped=true&lang=css"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00312755"]])

export default __exports__